import Dashboard from "./Dashboard";
export default function ProjectsIndex() { return <Dashboard />; }
